import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UpdateDialectsInput, UpdateDialectsPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UpdateDialectsInput;
type TData = UpdateDialectsPayload;

export const useClientAccountUpdateDialects = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation clientAccountUpdateDialects($input: UpdateDialectsInput!) {
      clientAccountUpdateDialects(input: $input) {
        success
        errors
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
